import { CHAR_NO_BREAK_SPACE, CHAR_EN_DASH } from '@taiga-ui/cdk';
import { TUI_DIGIT_REGEXP } from '@taiga-ui/core';

const DATE_TIME_SEPARATOR = ', ';

const EMPTY_MASK = {
    mask() {
        return false;
    },
};

const GROUP_CLASS_NAMES = [
    '_active',
    '_disabled',
    '_focused',
    '_focus-visible',
    '_hosted_dropdown_focused',
    'ng-invalid',
    'ng-touched',
    '_pressed',
    '_readonly',
];

const iconBlank = '<svg></svg>';

const TUI_PHONE_MASK = [
    '+',
    '7',
    ' ',
    TUI_DIGIT_REGEXP,
    TUI_DIGIT_REGEXP,
    TUI_DIGIT_REGEXP,
    ' ',
    TUI_DIGIT_REGEXP,
    TUI_DIGIT_REGEXP,
    TUI_DIGIT_REGEXP,
    '-',
    TUI_DIGIT_REGEXP,
    TUI_DIGIT_REGEXP,
    '-',
    TUI_DIGIT_REGEXP,
    TUI_DIGIT_REGEXP,
];
const TUI_TIME_MASK = [
    TUI_DIGIT_REGEXP,
    TUI_DIGIT_REGEXP,
    ':',
    TUI_DIGIT_REGEXP,
    TUI_DIGIT_REGEXP,
];
/**
 * @deprecated use {@link tuiCreateDateMask} (from '@taiga-ui/kit') instead
 * TODO remove in 3.0
 */
const TUI_DATE_MASK = [
    TUI_DIGIT_REGEXP,
    TUI_DIGIT_REGEXP,
    '.',
    TUI_DIGIT_REGEXP,
    TUI_DIGIT_REGEXP,
    '.',
    TUI_DIGIT_REGEXP,
    TUI_DIGIT_REGEXP,
    TUI_DIGIT_REGEXP,
    TUI_DIGIT_REGEXP,
];
/**
 * @deprecated use {@link tuiCreateDateRangeMask} (from '@taiga-ui/kit') instead
 * TODO remove in 3.0
 */
const TUI_DATE_RANGE_MASK = [
    ...TUI_DATE_MASK,
    CHAR_NO_BREAK_SPACE,
    CHAR_EN_DASH,
    CHAR_NO_BREAK_SPACE,
    ...TUI_DATE_MASK,
];

/**
 * Used as a limit for eliminating JS issues with floating point math
 */
const TUI_FLOATING_PRECISION = 7;

const MAX_DAY_RANGE_LENGTH_MAPPER = (min, value, maxLength, backwards) => {
    if (!value || !value.isSingleDay || !maxLength) {
        return min;
    }
    const dateShift = value.from
        .append(maxLength, backwards)
        .append({ day: 1 }, !backwards);
    if (backwards) {
        return dateShift.dayBefore(min) ? min : dateShift;
    }
    if (!min) {
        return dateShift;
    }
    return dateShift.dayAfter(min) ? min : dateShift;
};

const MAX_TIME_VALUES = {
    HH: 23,
    MM: 59,
    SS: 59,
    MS: 999,
};

const DEFAULT_ROUTER_LINK_OPTIONS = {
    fragment: '',
    preserveFragment: true,
    replaceUrl: false,
    skipLocationChange: false,
    queryParams: null,
    useHref: false,
    target: null,
};

/**
 * Generated bundle index. Do not edit.
 */

export { DATE_TIME_SEPARATOR, DEFAULT_ROUTER_LINK_OPTIONS, EMPTY_MASK, GROUP_CLASS_NAMES, MAX_DAY_RANGE_LENGTH_MAPPER, MAX_TIME_VALUES, TUI_DATE_MASK, TUI_DATE_RANGE_MASK, TUI_FLOATING_PRECISION, TUI_PHONE_MASK, TUI_TIME_MASK, iconBlank };

